import { LANG_DEFAULT, LANGUAGES, LANGUAGES_ACTIVE_LIST } from '@/base/const/lang.const'
import i18n, { loadLanguage } from '@/base/i18n/index'
import { CookieClass } from '@/base/class/cookie.class'
import { COOKIE_LANG } from '@/base/const/cookies.const'
import { Raven } from 'vue-raven'

const state = {
  current: LANG_DEFAULT,
  loading: false
}
const mutations = {
  SET_CURRENT_LANGUAGE (state, value) {
    state.current = value
  },
  SET_LANG_LOADING (state, value) {
    state.loading = value
  }
}
const actions = {
  setLanguage ({ commit, dispatch, rootState }, payload) {
    const value = typeof payload === 'string' ? payload : payload.value
    const silent = payload?.silent || false

    if (silent) {
      CookieClass.setCookie(COOKIE_LANG, value)
      return loadLanguage(value.toLowerCase())
        .then(() => {
          i18n.locale = value.toLowerCase()
          commit('SET_CURRENT_LANGUAGE', value)
          if (rootState.payment.paymentData && rootState.payment.paymentData.paywayGroups) {
            dispatch('getPaywaysLanguageData')
          }
        })
    }
    commit('SET_LANG_LOADING', true)
    CookieClass.setCookie(COOKIE_LANG, value)

    const MIN_LOADING_TIME = 1000
    const delay = new Promise(resolve => setTimeout(resolve, MIN_LOADING_TIME))

    return Promise.all([
      loadLanguage(value.toLowerCase()),
      delay
    ])
      .then(() => {
        i18n.locale = value.toLowerCase()
        commit('SET_CURRENT_LANGUAGE', value)
        if (rootState.payment.paymentData && rootState.payment.paymentData.paywayGroups) {
          dispatch('getPaywaysLanguageData')
        }
      })
      .catch((error) => {
        Raven.captureMessage('loadLanguage action error in lang.js', {
          extra: { error }
        })
      })
      .finally(() => {
        setTimeout(() => {
          commit('SET_LANG_LOADING', false)
        }, 100)
      })
  }
}
const getters = {
  getCurrentLanguage (state, getters) {
    const languagesList = getters.getAvailableLanguagesList
    if (!state.current || !languagesList.includes(state.current)) {
      return LANG_DEFAULT
    }
    return state.current
  },
  getAvailableLanguagesList (state, getters, rootState) {
    const paymentData = rootState.payment.paymentData
    const confirmationData = rootState.confirmation.data
    if (paymentData) {
      const languagesAvailable = paymentData.languageData?.languagesAvailable || []
      return LANGUAGES_ACTIVE_LIST.filter(x => languagesAvailable.includes(x))
    } else if (confirmationData) {
      const languagesAvailable = confirmationData.languageData?.languagesAvailable || []
      return LANGUAGES_ACTIVE_LIST.filter(x => languagesAvailable.includes(x))
    }
    return LANGUAGES_ACTIVE_LIST
  },
  isDefaultLangActive (state) {
    return state.current === LANG_DEFAULT
  },
  isLangForYourCxActive (state) {
    return [LANGUAGES.pl, LANGUAGES.de].includes(state.current)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
